import { render, staticRenderFns } from "./WeakUserRate.vue?vue&type=template&id=66e939fe&"
import script from "./WeakUserRate.vue?vue&type=script&lang=js&"
export * from "./WeakUserRate.vue?vue&type=script&lang=js&"
import style0 from "./WeakUserRate.vue?vue&type=style&index=0&id=66e939fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports